import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type TriangleRulerProps = {
    className?: string;
};

const TriangleRuler: FunctionComponent<TriangleRulerProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'triangle-ruler'}
            viewBox="0 0 250 250"
        >
            <path d="M58 139.8l54.6 54.7H58v-54.7m-5-12v71.7h71.6L53 127.8z" />
            <path d="M0-.2v250.4h250L0-.2zm5 12.1l33.4 33.4-15.1 15.2c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7L42 48.9l17.4 17.4-9.1 9.1c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l9.1-9.1 16.9 16.9-15.1 15.1c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l15.1-15.1 17.4 17.4-9.1 9.1c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l9.1-9.1 15.5 15.5-15.1 15.1c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l15.1-15.1 17.4 17.4-9.1 9.1c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l9-9 16.9 16.9-15 15c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l15-15 17.4 17.4-9 9c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l9-9 16 16-15 15c-1 1-1 2.6 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l15-15 33 33-233.6.3V11.9z" />
        </svg>
    );
};
export default TriangleRuler;
